export default __webpack_public_path__ + "static/media/noun_Compare_3133212.445a3bfd.svg";